"use strict";
// var { fragments } = require("../fragments");

var _parent = {};
let log = false;

module.exports = {
  init: (p) => (_parent = p),
  /**
   *
   * @param {Object} repairOrderObjects Array of repair order objects to insert
   */
  create: async function (repairordersObjectArray) {
    try {
      let res = await _parent.gql.mutation(
        `mutation sdk_insert_repairorders(
            $repairordersObjectArray: [repairorders_insert_input!]!
            ) { insert_repairorders(objects: $repairordersObjectArray) {
                affected_rows
                returning {
                    id
                    repair_order_number
                    total_labor_cost
                    total_part_cost
                    service_line_items_count
                    labor_operations_count
                    parts_count
                    PO_number
                    transport_type
                    customer_id
                    createdat
                    updatedat
                }
            }
          }
        `,
        { repairordersObjectArray: repairordersObjectArray }
      );
      //response will be standardized object created by handler
      return res;
    } catch (err) {
      throw err;
    }
  },
};
